// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SetupFee_EmitResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SetupFee_EmitResponseDados {
charge_id: number
status: string
provider_charge_id: string
checkout_url: string
currency: string
amount_cents: number
installments: number
}

export type SetupFee_EmitResponse = ApiResponse<SetupFee_EmitResponseDados>;

registerResponseContract('SetupFee_EmitResponse', {
  charge_id:          { type: 'number',  required: true },
  status:             { type: 'string',  required: true },
  provider_charge_id: { type: 'string',  required: true },
  checkout_url:       { type: 'string',  required: true },
  currency:           { type: 'string',  required: true },
  amount_cents:       { type: 'number',  required: true },
  installments:       { type: 'number',  required: true },
})
